import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IRecordTimeOffFormData {
  user_id: string;
  category_id: string;
  start: string | undefined;
  end: string | undefined;
  requested_hours?: string | null;
  requested_hours_type: string;
  description: string;
}

const recordTimeOff = (postData: IRecordTimeOffFormData) => {
  return http().post(endpoints.timeOff.recordTimeOff, postData);
};

export function useRecordTimeOff() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: recordTimeOff,
    onSettled: (data: any) => {
      if (data) {
        queryClient.invalidateQueries(['fetchLeaveBalances']);
      }
    },
  });
}
